import React, { useRef, useEffect, useState } from "react";
import MainCard from "ui-component/cards/MainCard";
import Admin from "views/Components/ServicesOperationComponent/Admin/Admin";
import {
  SelectedRowProvider,
  useSelectedRow,
} from "../../../../contexts/SelectedRowContext";
import { createTheme } from "@mui/material/styles";
import { useParams } from "react-router-dom";
import { Stack, Typography } from "@mui/material";
import LayersOutlinedIcon from "@mui/icons-material/LayersOutlined";
const ServiceOperationPage = (props) => {
  const { id } = useParams();
  const divRef = useRef(null);
  const [size, setSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    // size update
    const updateSize = () => {
      if (divRef.current) {
        const { width, height } = divRef.current.getBoundingClientRect();
        //console.log(width, height)
        setSize({ width, height });
      }
    };

    // set initial size
    updateSize();

    window.addEventListener("resize", updateSize);

    // remove event controller
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  const theme = createTheme({
    typography: {
      fontFamily: '"Montserrat", sans-serif',
    },
  });

  return (
    <div style={mainDiv} ref={divRef}>
      <Stack spacing={1}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 600,
            fontSize: "32px",
            color: "#000000DE",
            lineHeight: "24px",
          }}
        >
          Backlog de reparaciones
        </Typography>
        <Typography
          variant="body2"
          sx={{
            fontWeight: 400,
            fontSize: "14px",
            color: "#000000DE",
            lineHeight: "24px",
          }}
        >
          SOA · Administrador de taller — Asignación y gestión de tickets
        </Typography>
      </Stack>
      <Stack direction="row" alignItems="center" spacing={0.5} mt={2}>
        <LayersOutlinedIcon
          sx={{
            width: "24px",
            height: "24px",
            fill: "#00000099",
          }}
        />
        <Typography>Reparaciones</Typography>
      </Stack>
      <Admin id={id} />
    </div>
  );
};

export default ServiceOperationPage;

const mainDiv = {
  height: "100%",
  border: "0px solid black",
};

const mainCard = {
  height: "100%",
  border: "0px solid red",
  fontFamily: "Montserrat, sans-serif",
};
